export default ({ savedItems: { showSuccessBanner } }) => !!showSuccessBanner;
